<template>
  <el-dialog title="导入"
             :visible.sync="dialogVisible"
             :show-close="false"
             custom-class="importDialog"
             :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="form"
             :rules="rules"
             ref="refDialog"
             label-width="100px">
      <!-- <el-form-item label="活动名称" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>-->
      <el-row>
        <el-col :span="12">
          <el-form-item prop="profession"
                        label="行业">
            <el-select clearable
                       v-model="form.profession"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in platlists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="business"
                        label="商家">
            <el-select v-loading="ptnListLoading"
                       clearable
                       v-model="form.business"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in ptnlists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="store"
                        label="店铺">
            <el-select v-loading="shopListLoading"
                       clearable
                       v-model="form.store"
                       placeholder="请选择"
                       style="width: 90%">
              <el-option v-for="item in shoplists"
                         :key="item.id"
                         :label="item.name"
                         :value="item.code">{{ item.name }}</el-option>
            </el-select>
          </el-form-item>

        </el-col>
      </el-row>
      <el-form-item label="文件"
                    required>
        <el-upload :on-remove="handleRemove"
                   class="upload-demo"
                   drag
                   action="fake"
                   accept=".xlsx, .xls, .csv"
                   :limit="1"
                   :auto-upload="false"
                   :on-change="handleChange"
                   ref="refUpload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <!-- <div class="el-upload__trigger" slot="trigger">只能上传 xlsx文件，且不超过 30M</div> -->
          <div class="el-upload__tip"
               slot="tip">只能上传 xlsx xls csv文件，且不超过 30M</div>
          <div class="el-upload__tip"
               slot="tip">
            <el-col :span="12">
              <el-form-item label-width="0px">
                <el-button type="primary"
                           icon="el-icon-document"
                           @click="downloadTemp">点击下载模板文件</el-button>
              </el-form-item>
            </el-col>
          </div>
        </el-upload>
      </el-form-item>

    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="hide">取 消</el-button>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { resolvingXLSX } from '@/utils'
import * as Desc from './desc'
import { getplatlists, getptnlists, getshoplists } from '@/common/mixins/select'
import { dealReturn } from '@/common/js/index.js'
export default {
  mixins: [getplatlists, getptnlists, getshoplists],
  name: 'ImportDialog',
  data() {
    return {
      dialogVisible: false,
      rules: {},
      Desc,
      form: {
        profession: '',
        business: '',
        store: '',
      },
      formworkFile: '',
      rules: {
        profession: [{ required: true, message: '必填项', trigger: 'blur' }],
        business: [{ required: true, message: '必填项', trigger: 'blur' }],
        store: [{ required: true, message: '必填项', trigger: 'blur' }],
      },
      file: null,
      fileHeader: [],
    }
  },
  created() {
    // this.getTableData();
    this.getImportTemp()
  },
  methods: {
    async getImportTemp() {
      // this.loading = true

      // let name = this.$route.meta.routeName.split('.')[1]
      let name = this.$route.name
      console.log('route', this.$route)
      console.log(name)
      let { data, err } = await this.axiosApi({
        url: `getFormworkFile/${name}`,
      })
      if (data && data.data.meta.status === 200) {
        console.log('data', data.data.data)
        this.formworkFile = data.data.data
      }
    },
    downloadTemp() {
      if (this.formworkFile) {
        window.location.href = this.formworkFile
      }
    },
    show(list) {
      console.log('导入文件头 信息', list)
      this.fileHeader = list
      console.log(this.fileHeader, 'fileHeader23')
      this.dialogVisible = true
    },
    hide() {
      this.dialogVisible = false
      this.handleFileReset()
    },
    handleFileReset() {
      this.file = null
      this.form = { profession: '', business: '', store: '' }
      this.$refs.refDialog.resetFields()
      this.$refs.refUpload.clearFiles()
    },
    handleRemove(file, fileList) {
      console.log('file, fileList', file, fileList)
      this.file = null
    },
    handleChange(file, fileList) {
      console.log('handleChange file', file)
      let list = file.name.split('.')
      let suffix = list[list.length - 1]
      let arr = ['xlsx', 'xls', 'csv']
      if (!arr.includes(suffix)) {
        this.$refs.refUpload.clearFiles()
        this.$message.error('导入模板有误，请检查导入文件格式')
      } else {
        this.file = file.raw
      }
    },
    async submit() {
      let isValid
      this.$refs.refDialog.validate((valid) => {
        isValid = valid
      })
      if (!isValid) {
        return
      }

      // else
      if (!this.file) {
        this.$message.error({
          message: '请添加文件',
          // offset: 61,
        })
        return
      }
      if (this.file.size > 30 * 1024 ** 2) {
        this.$message.error({
          message: '文件大小不能超过 30M',
          // offset: 61,
        })
      } else {
        // 判断文件 列的数目
        // debugger;
        const bool = await resolvingXLSX(this.file, this.fileHeader)
        console.log('bool', bool)
        
        // reportname 当前页面的URL
        console.log('this.$route', this.$route)
        this.form.file = this.file
        this.form.reportname = this.$route.path.replace('/', '')
        // this.$emit('submit', this.form)
        this.getsmt()
        
        // 取消文件校验 导入
        // if (bool) {
        //   // reportname 当前页面的URL
        //   console.log('this.$route', this.$route)
        //   this.form.file = this.file
        //   this.form.reportname = this.$route.path.replace('/', '')
        //   this.$emit('submit', this.form)
        //   this.hide()
        // } else {
        //   this.$message.error('导入模板有误2，请检查导入文件内容')
        //   console.log('this.$route', this.$route)
        //   this.form.file = this.file
        //   this.form.reportname = this.$route.path.replace('/', '')
        //   // this.$emit("submit", this.form);
        //   this.hide()
        // }
      }

      // 相父组件派发事件和数据
    },
    // 导入
    async getsmt() {
      // debugger;
      let form = this.form
			let formData = new FormData()
			for (let key in form) {
				formData.set(key, form[key])
			}
			// 各个页面的上传url 定义在 desc.js 的 upload_api 中
			// 现在有一个需求，推广下的所有页面使用同一个url promoteDataUpload
			// 为了不去一个个文件里写，在这里统一手动赋值
			// 有路由层级的数据的菜单 在sessionStorage menulist
      console.log(this.Desc, 'Desc')
			let upload_api = this.Desc.upload_api ? this.Desc.upload_api : this.currentModule.upload
			// if (this.$route.path)
			console.log('this.$route.path', this.$route.path)
			let { data, err } = await this.axiosApi(upload_api, formData)
			if (data && data.status === 200) {
				// let type = (data.data && (data.data.message || data.data.message.indexOf('未完成') == -1)) ? 'success' : 'error'
				// this.$message({
				// 	type: type,
				// 	message: (data.data && data.data.message) ? data.data.message : ''
				// 	// offset: 61
				// })
        console.log(data, 'data')
        if(data.data.data.status == 'success'){
          let cfmrst = await this.$confirm(
            data.data.data.message, "提示",
            { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", }
          ).catch((err) => {
            this.hide()
          })
          if(cfmrst == 'confirm'){
            this.getmodifState(data.data.data.oid)
            // let parm = {
            //   profession: this.form.profession,
            //   business: this.form.business,
            //   store: this.form.store,
            //   sid: data.data.data.sid
            // }
            // this.$emit('sucmit', parm)
            this.hide()
            // this.handleFileReset()
          }
        }else if(data.data.data.status == 'first'){
          let cfmrst = await this.$confirm(
            data.data.data.message, "提示",
            { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", }
          ).catch((err) => {
            this.hide()
          })
          if(cfmrst == 'confirm'){
            // this.getmodifState(data.data.data.oid)
            let parm = {
              profession: this.form.profession,
              business: this.form.business,
              store: this.form.store,
              sid: data.data.data.sid,
              oid: data.data.data.oid,
              status: data.data.data.status
            }
            this.$emit('submit', parm)
            this.hide()
          }else{
            this.getcancelBySurvey(data.data.data)
          }

        }
			} else {
				dealReturn(data, err)
			}
    },
    // modifState oid
    async getmodifState(oid) {
      let query = {
        url: 'modifState',
        method: 'post',
        title: 'oid'
      }
      let parm = {
        oid: oid
      }
      let { data, err } = await this.axiosApi(query, parm)
      if(data.status == 200){
        // this.$message.success(data.data.data)
      }
    },
    // 默认first导入取消操作
    async getcancelBySurvey(e) {
      let query = {
        url: 'cancelBySurvey',
        method: 'post',
        title: 'oid'
      }
      let parm = {
        oid: e.oid,
        sid: e.sid,
        status: e.status
      }
      let { data, err } = await this.axiosApi(query, parm)
      if(data.status == 200){
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper >>> {
  .importDialog {
    width: 600px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/base/memberquesrgath/importDialog/index.vue